import type { StorageUnit } from 'store/storageunits/types';

const THUMBNAILS_LOCAL_STORAGE_KEY = 'pd-thumbnails';

type LegacyThumbnail = {
  img: string;
  date: string;
};

type LegacyThumbnailsMap = Record<string, LegacyThumbnail>;

/**
 * Get legacy thumbnails from localStorage
 * These were stored by the old system before thumbnails were moved to backend
 */
const getLegacyThumbnails = (): LegacyThumbnailsMap => {
  try {
    const data = localStorage.getItem(THUMBNAILS_LOCAL_STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    //ToDo: log error in Sentry
    return {};
  }
};

/**
 * ToDo: remove this after a reasonable transition period
 */
export const enhanceWithLegacyThumbnails = (
  storageUnits: StorageUnit[],
): StorageUnit[] => {
  const anyMissingThumbnails = storageUnits.some((unit) => !unit.thumbnail);

  if (!anyMissingThumbnails) {
    return storageUnits;
  }

  const legacyThumbnails = getLegacyThumbnails();

  if (Object.keys(legacyThumbnails).length === 0) {
    return storageUnits;
  }

  return storageUnits.map((unit) => {
    if (!unit.thumbnail && legacyThumbnails[unit.id]) {
      return {
        ...unit,
        thumbnail: legacyThumbnails[unit.id].img,
      };
    }
    return unit;
  });
};
